import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@perval/shared';
import { catchError, firstValueFrom, map, of } from 'rxjs';

interface LoginAvailabilityHttp {
  login_already_exists: boolean;
}

/**
 * Vérifie la disponibilité d'un identifiant utilisateur pendant l'inscription,
 * via l'endpoint public et anonyme dédié `customers/login/{login}/availability`
 * (ne renvoie qu'un booléen, aucune donnée utilisateur). Toute erreur technique
 * est traitée comme "disponible" pour ne pas bloquer l'utilisateur en cas
 * d'indisponibilité du service.
 */
@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private readonly mainUrl = `${environment.baseApiUrl}/perval-utilisateurs`;

  constructor(private readonly http: HttpClient) {}

  public async isLoginTaken(login: string): Promise<boolean> {
    return firstValueFrom(
      this.http
        .get<LoginAvailabilityHttp>(
          `${this.mainUrl}/customers/login/${login}/availability`,
        )
        .pipe(
          map((response) => response.login_already_exists),
          catchError(() => of(false)),
        ),
    );
  }
}
